import React from 'react';
import Switch from '../../../../../common/components/Switch/Switch';
import './SwitchStatus.pcss';

type Props = {
  active: boolean;
  disabled: boolean;
  onChange: () => void;
};

export const SwitchStatus = (props: Props) => {
  const { active, disabled, onChange } = props;

  return (
    <div>
      <div className="status-container">
        <span className="status-text">Status:</span>
        <Switch checked={active} disabled={disabled} onChange={onChange} />
      </div>
    </div>
  );
};
